import { render } from "./TenantUserEditRoleDialog.vue?vue&type=template&id=f5aaaa6a"
import script from "./TenantUserEditRoleDialog.vue?vue&type=script&lang=js"
export * from "./TenantUserEditRoleDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__